"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeColors = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const tinycolor2_1 = __importDefault(require("tinycolor2"));
const constants_1 = require("./constants");
const clamp = (number, min, max) => Math.min(Math.max(number, min), max);
const clampColorValue = (value) => clamp(value, 0, 255);
const shiftColor = (color, amount, 
// adding this as a future option, since I have all the logic worked out
method) => {
    const colorAsNumber = parseInt(color.slice(1), 16);
    const baseR = colorAsNumber >> 16;
    const baseG = (colorAsNumber >> 8) & 0x00ff;
    const baseB = colorAsNumber & 0x0000ff;
    const operand = method === 'absolute'
        ? (value) => value + amount
        : (value) => value + value * amount;
    const [shiftedR, shiftedG, shiftedB] = [baseR, baseG, baseB].map((value) => clampColorValue(operand(value)));
    const shiftedHex = (shiftedB | (shiftedG << 8) | (shiftedR << 16))
        .toString(16)
        .padStart(6, '0');
    return `#${shiftedHex}`;
};
const getPaletteColor = (palettes, key) => {
    const [palette, subkey] = key.split('.');
    return palettes[palette][subkey];
};
const mapSystemPalettes = (mergedColorTheme, brightnessPalette) => {
    const systemEntries = constants_1.UX_COLOR_SYSTEMS.map((system) => {
        const paletteEntries = constants_1.BASIC_PALETTE_KEYS.map((key) => [
            key,
            getPaletteColor(mergedColorTheme.palettes, mergedColorTheme.maps[brightnessPalette][system][key]),
        ]);
        return [system, Object.fromEntries(paletteEntries)];
    });
    return Object.fromEntries(systemEntries);
};
const mergeColors = (baseColors, overrideColors, palette) => {
    const brandPrimaryColor = overrideColors.brand?.primary ?? baseColors.brand.primary;
    const mergedColorTheme = (0, merge_1.default)(baseColors, overrideColors);
    const accessibleOverPrimary = tinycolor2_1.default
        .mostReadable(brandPrimaryColor, ['#0D0D0D', '#fff'])
        .toHexString(); // We know this is a HexColor (`#${string}`)
    return {
        brand: {
            primary: brandPrimaryColor,
            light: shiftColor(brandPrimaryColor, 0.12, 'percentage'),
            dark: shiftColor(brandPrimaryColor, -0.12, 'percentage'),
            accessibleOverPrimary,
        },
        text: Object.fromEntries(constants_1.TEXT_COLOR_KEYS.map((key) => [
            key,
            getPaletteColor(mergedColorTheme.palettes, mergedColorTheme.maps[palette].text[key]),
        ])),
        background: Object.fromEntries(constants_1.BACKGROUND_COLOR_KEYS.map((key) => [
            key,
            getPaletteColor(mergedColorTheme.palettes, mergedColorTheme.maps[palette].background[key]),
        ])),
        ...mapSystemPalettes(mergedColorTheme, palette),
    };
};
exports.mergeColors = mergeColors;
//# sourceMappingURL=mergeColors.js.map